/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CompartmentDetailsForOCI extends models.CompartmentDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("CompartmentDetailsForOCI");
    }

    getFixupPrototypeFunction() { return CompartmentDetailsForOCI.fixupPrototype; }

    static newInstance(model: Partial<CompartmentDetailsForOCI>): CompartmentDetailsForOCI {
        let obj = Object.assign(new CompartmentDetailsForOCI(), model);
        CompartmentDetailsForOCI.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CompartmentDetailsForOCI>): CompartmentDetailsForOCI {
        if (!model) return null;
        return CompartmentDetailsForOCI.newInstance(<CompartmentDetailsForOCI> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CompartmentDetailsForOCI) {
        if (!obj) return;

        models.CompartmentDetailsForOCI.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CompartmentDetailsForOCI): boolean {
        if (models.CompartmentDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CompartmentDetailsForOCI.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
